import { toast as sonnerToast } from 'sonner';

const DEFAULT_DURATION_MS = 5000;

const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARN: 'warning',
    WARNING: 'warning',
    INFO: 'info',
    DEFAULT: 'info',
};

const resolveDuration = (options = {}) => {
    if (options.autoClose === false) return Infinity;
    if (typeof options.autoClose === 'number') return options.autoClose;
    return DEFAULT_DURATION_MS;
};

const resolveVariant = (type) => {
    if (!type) return 'info';
    if (type === TYPE.SUCCESS || type === 'success') return 'success';
    if (type === TYPE.ERROR || type === 'error') return 'error';
    if (type === TYPE.WARN || type === TYPE.WARNING || type === 'warn' || type === 'warning') {
        return 'warning';
    }
    return 'info';
};

const baseOptions = (options = {}) => {
    const duration = resolveDuration(options);
    const className = [
        'app-toast',
        options.hideProgressBar ? 'app-toast--no-progress' : '',
    ]
        .filter(Boolean)
        .join(' ');

    return {
        duration,
        className,
        closeButton: options.closeButton !== false,
    };
};

const emit = (variant, message, options = {}) => {
    const opts = baseOptions(options);
    switch (variant) {
        case 'success':
            return sonnerToast.success(message, opts);
        case 'error':
            return sonnerToast.error(message, opts);
        case 'warning':
            return sonnerToast.warning(message, opts);
        default:
            return sonnerToast.info(message, opts);
    }
};

const update = (toastId, options = {}) => {
    if (toastId == null) return;
    const message = options.render ?? options.message ?? '';
    const variant = resolveVariant(options.type);
    const opts = {
        ...baseOptions(options),
        id: toastId,
    };
    emit(variant, message, opts);
};

export const toast = {
    success: (message, options) => emit('success', message, options),
    error: (message, options) => emit('error', message, options),
    warn: (message, options) => emit('warning', message, options),
    warning: (message, options) => emit('warning', message, options),
    info: (message, options) => emit('info', message, options),
    update,
    dismiss: (toastId) => sonnerToast.dismiss(toastId),
    TYPE,
};

export default toast;
